type State = {
  [key: string]: boolean;
};

const state: State = {};

export function useGlobalOneShot(
  key: string,
  value = false
): {
  call: (
    callback: () => void,
    isReset?: boolean,
    beforeCall?: () => void,
    afterCall?: () => void
  ) => void;
  initialize: () => void;
} {
  if (state[key] === undefined) {
    state[key] = value;
  }

  async function call(
    callback: () => void,
    isReset = true,
    beforeCall: () => void = () => {
      return;
    },
    afterCall: () => void = () => {
      return;
    }
  ) {
    if (state[key]) {
      return;
    }
    state[key] = true;
    if (beforeCall) {
      await beforeCall();
    }
    await callback();
    if (afterCall) {
      await afterCall();
    }
    if (isReset) {
      state[key] = false;
    }
  }

  function initialize() {
    state[key] = false;
  }

  return { call, initialize };
}
